import { atom } from 'jotai'

export const unskipOrderModalAtom = atom<{
  isOpen: boolean
  date: string | null
  product: any | null
}>({
  isOpen: false,
  date: null,
  product: null
})
